// extracted by mini-css-extract-plugin
export default {"ref":"AboutUs_dev_ref__UdTNs","content":"AboutUs_dev_content__-faqa"};